import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import axios from 'axios';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    pageName:"網站導覽",
    path: '/guide',
    name: 'guide',
    component: () => import('../views/guide.vue'),
  },
  {
    pageName:"最新消息",
    path: '/newsMessageAll',
    name: 'NewsMessageAll',
    component: () => import('../views/newsMessageAll.vue'),
  },
  {
    //最新消息的內容
    path: '/newsContent',
    name: 'newsContent',
    component: () => import('../views/newsContent.vue'),
    props: true
  },
  {
    pageName:"學院介紹",
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  },
  {
    pageName:"相關法規",
    path: '/regulation',
    name: 'regulation',
    component: () => import('../views/regulation.vue')
  },
  {
    pageName:"團隊成員",
    path: '/teamMember',
    name: 'teamMember',
    component: () => import('../views/teamMember.vue'),
    props: true
  },
  {
    //成員內容
    path: '/memberContent',
    name: 'memberContent',
    component: () => import('../views/teamMemberContent.vue'),
    props: true
  },
  {
    pageName:"學程介紹",
    path: '/course',
    name: 'course',
    component: () => import('../views/course.vue'),
    props: true, // 將所有路由參數作為props傳遞給component
  },


  {
    pageName:"日誌",
    path: '/magazine',
    name: 'magazine',
    component: () => import('../views/magazine.vue'),
    props: true
  },
  {
    //活動紀錄的內容
    path: '/content',
    name: 'content',
    component: () => import('../views/content.vue'),
    props: true
  },
  {
    pageName:"自主學習",
    path: '/learn',
    name: 'learn',
    component: () => import('../views/learn.vue'),
  },
  
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {

    if (to.path !== '/magazine' || from.path !== '/magazine') {
      // 如果不是在 /magazine 页面切换 tag，将页面滚动至顶部
      return { x: 0, y: 0 };
    } else if (savedPosition) {
      // 在 /magazine 页面内切换 tag，且之前有保存的滚动位置，则恢复之前的位置
      return savedPosition;
    }
  }

})

// 在每次导航之前检查路由
router.beforeEach((to, from, next) => {
  // 检查要导航到的路由是否存在
  const routeExists = router.options.routes.some(route => route.path === to.path)

  if (!routeExists) {
    // 如果路由不存在，重定向到首页
    next('/')
  } else {
    // 路由存在，正常导航
    next()
  }
})

export default router
